import React, { Component } from 'react';
import PropTypes from 'prop-types';

// All sections in the card goes here !!!
import ActionSection from './ActionSection.jsx';
import FinancialsSection from './FinancialsSection.jsx';
import StageSection from './StageSection.jsx';
import WriteOffReasonSection from './WriteOffReasonSection.jsx';
import CaseNoteSection from './CaseNoteSection.jsx';
import TimelineDocument from '../TimelineDocument/TimelineDocument.jsx';
import QuestionnairreResponse from './QuestionnairreResponse.jsx';
import ReasonAdditionalReviewSection from './ReasonAdditionalReviewSection.jsx';

const TimelineCard = (props) => {
    const { configEventCode } = props; 
    let cardContent = [];
    props.listItem.eventBodyDetails.forEach(section => {

        if (section.sectionCode === 'WRITEOFF_REASON' && (props.filterSet.includes('WRITEOFF_REASON') || props.filterSet.includes('All'))) {
            cardContent = cardContent.concat(
                <WriteOffReasonSection
                    eventCode={props.listItem.eventHeaderDetails.eventCode}
                    {...section}
                />)
        }

        
        if (section.sectionCode === 'ACTION' && (props.isNewStage || props.isAddInfo || props.isStageClose) && props.filterSet.includes('All')) {
            cardContent = cardContent.concat(
                <StageSection
                    configEventCode={configEventCode}
                    eventCode={props.listItem.eventHeaderDetails.eventCode}
                    stageName={props.listItem.disputeStageName}
                    {...section}
                    isAddInfo = {props.isAddInfo}
                    isNewStage = {props.isNewStage}
                    isStageClose = {props.isStageClose}
                    dateFormat={props.dateFormat}
                />)
        }
        
        if(props.cardBrandCode === 'VI' || props.cardBrandCode === 'MC'){
        if ((section.sectionCode === 'ACTION') && (props.listItem.eventHeaderDetails.eventCode =='RESPONSE_TO_ISSUER') && (props.filterSet.includes('ACTION') || props.filterSet.includes('All')) && !props.isNewStage && !props.isAddInfo && !props.isStageClose) {
            cardContent = cardContent.concat(
                <QuestionnairreResponse
                listItem={props.listItem}
                cardBrandCode={props.cardBrandCode}
                toggleDrawer={props.toggleDrawer}
                getApiDrawerData={props.getApiDrawerData}
                />)
        }
    }
        if ((section.sectionCode === 'ACTION_MERCHANT' || section.sectionCode === 'ACTION') && (props.filterSet.includes('ACTION') || props.filterSet.includes('All')) && !props.isNewStage && !props.isAddInfo && !props.isStageClose) {
            cardContent = cardContent.concat(
                <ActionSection
                    configEventCode={configEventCode}
                    eventCode={props.listItem.eventHeaderDetails.eventCode}
                    stageName={props.listItem.disputeStageName}
                    timeStamp={props.listItem.eventHeaderDetails.eventTimeStamp}
                    merchantChallengeType={props.listItem.merchantChallengeType}
                    isMerchantUser={props.isMerchantUser} 
                    dateFormat={props.dateFormat}
                    historyData = {props.historyData}
                    cardBrandCode={props.cardBrandCode}
                    {...section}
                />)
        }
        if (section.sectionCode === 'RSN_ADTNL_RVW') {
            cardContent = cardContent.concat(<ReasonAdditionalReviewSection
                eventCode={props.listItem.eventHeaderDetails.eventCode}
                {...section}
            />)
        }
        if (section.sectionCode === 'MERCHANT_ADVICE' && (props.filterSet.includes('MERCHANT_ADVICE') || props.filterSet.includes('All'))) {
            cardContent = cardContent.concat(<TimelineDocument
                eventCode={props.listItem.eventHeaderDetails.eventCode}
                caseNumber={props.caseNumber}
                isMerchantUser={props.isMerchantUser} 
                dateFormat={props.dateFormat}
                isArchival={props.isArchival}
                {...section}
            />)
        }
        if ((section.sectionCode === 'DOCUMENTS' || section.sectionCode === 'SUMMARY_DOC') && (props.filterSet.includes('DOCUMENTS') || props.filterSet.includes('All') || props.filterSet.includes('SUMMARY_DOC')) && section.fields.DocumentList && section.fields.DocumentList.length > 0) {
            cardContent = cardContent.concat(<TimelineDocument
                eventCode={props.listItem.eventHeaderDetails.eventCode}
                caseNumber={props.caseNumber}
                isMerchantUser={props.isMerchantUser} 
                dateFormat={props.dateFormat}
                isArchival={props.isArchival}
                {...section}
            />)
        }
        if (section.sectionCode === 'FINANCIALS' && (props.filterSet.includes('FINANCIALS') || props.filterSet.includes('All'))) {
            cardContent = cardContent.concat(<FinancialsSection
                eventCode={props.listItem.eventHeaderDetails.eventCode}
                {...section}
            />)
        }

        if (section.sectionCode === 'NOTES' || section.sectionCode === 'EXTERNAL_NOTES' && (props.filterSet.includes('NOTES') || props.filterSet.includes('All'))) {
            cardContent = cardContent.concat(<CaseNoteSection
                eventCode={props.listItem.eventHeaderDetails.eventCode}
                {...section}
            />)
        }

    });

    return (
        cardContent
    );
};

TimelineCard.propTypes = {
    callUnlinkBanner: PropTypes.func,
    listItem: PropTypes.object.isRequired,
    data: PropTypes.object,
    isArchival: PropTypes.bool,
};

TimelineCard.defaultProps = {
    callUnlinkBanner: () => { },
    data: {},
    isArchival: false,
};

export default TimelineCard;
